import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';

export const isLoggedInGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);

  return auth.isAuthenticated$.pipe(
    take(1),
    map(isAuthenticated => {
      return !!isAuthenticated; // true if logged in, false otherwise
    })
  );
};